export { default } from "pathe";
// Named re-exports so CJS `require("@-/com.npmjs.pathe").resolve` works when Expo
// (and other Node CJS loaders) compile ESM default-import call sites.
export * from "pathe";
